import { UPDATE_COMMENT_LIKES } from 'root/src/client/logic/comment/actionIds'

export default body => ({
	type: UPDATE_COMMENT_LIKES,
	payload: body,
})
